module.exports = __webpack_public_path__ + "img/banner11@2x.ce516f1d.png";